import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

import {
  ANALYTICS_QUERY_KEY,
  toAnalyticsQuery,
  type AnalyticsFilters,
} from "./useSummary";

export function useHoldTimeBreakdown(filters: AnalyticsFilters = {}) {
  const client = useApiClient();
  return useQuery({
    queryKey: [...ANALYTICS_QUERY_KEY, "hold-time-breakdown", filters],
    queryFn: async () => {
      const { data, error } = await client.GET(
        "/api/analytics/hold-time-breakdown",
        { params: { query: toAnalyticsQuery(filters) } },
      );
      if (error !== undefined) {
        throw new Error("Failed to load hold-time breakdown");
      }
      return data;
    },
  });
}
